// Minimal service worker registration helper
// Registers /service-worker.js (placed in public/) when running in production

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === "::1",
);

export function register(config) {
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;

    // On localhost, do not register a SW that may cache files during development.
    if (isLocalhost) {
      // Optionally skip registration for localhost
      console.info("Service worker not registered on localhost.");
      return;
    }

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        console.log("Service Worker registered:", registration);
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;
          installingWorker.onstatechange = () => {
            if (installingWorker.state === "installed") {
              if (navigator.serviceWorker.controller) {
                console.log("New content is available; please refresh.");
                if (config && config.onUpdate) config.onUpdate(registration);
              } else {
                console.log("Content is cached for offline use.");
                if (config && config.onSuccess) config.onSuccess(registration);
              }
            }
          };
        };
      })
      .catch((error) => {
        console.error("Error during service worker registration:", error);
      });
  }
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let registration of registrations) {
        registration.unregister().catch(() => {});
      }
    });
  }
}

export default { register, unregister };
